import { render, staticRenderFns } from "./matchGiftRely.vue?vue&type=template&id=5d1c0f10&scoped=true"
import script from "./matchGiftRely.vue?vue&type=script&lang=js"
export * from "./matchGiftRely.vue?vue&type=script&lang=js"
import style0 from "./matchGiftRely.vue?vue&type=style&index=0&id=5d1c0f10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1c0f10",
  null
  
)

export default component.exports